import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/store";

export interface DialerReducerInterface {
  showDialer: boolean;
  no: Nullable<string>;
  contact: null | ContactRefType;
}

const initialState: DialerReducerInterface = {
  showDialer: false,
  no: "",
  contact: null,
};

const dialerSlice = createSlice({
  name: "dialer",
  initialState,
  reducers: {
    showDialer(state, action: PayloadAction<{ no?: Nullable<string>; contact?: ContactRefType }>) {
      state.showDialer = true;
      state.contact = action.payload.contact || null;
      state.no = action.payload.no || null;
    },
    hideDialer(state) {
      state.showDialer = false;
      state.no = null;
    },
    toggleDialer(state) {
      state.showDialer = !state.showDialer;
    },
  },
});

export const { showDialer, hideDialer, toggleDialer } = dialerSlice.actions;
export const dialerSelector = (state: RootState) => state.dialer;
export default dialerSlice.reducer;
